var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.minimenu)?_c('mini-menu'):_vm._e(),_c('page-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }